import React, { useContext, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import { Link } from "react-router-dom";
import AuthContext from "../../context/auth/authContext";
import FriendContext from "../../context/friending/friendContext";
import SpotReviewItemV2 from "../spots/SpotReviewItemV2";
import TripItem from "../trips/TripItem";

const FollowingFeed = () => {
  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;
  const friendContext = useContext(FriendContext);
  const {
    feedReviews, feedReviewsPage, feedReviewsTotal,
    feedTrips, feedTripsPage, feedTripsTotal,
    getFeedReviews, getFeedTrips,
  } = friendContext;

  const [tab, setTab] = useState(0);

  useEffect(() => {
    loadUser();
    getFeedReviews(1);
    getFeedTrips(1);
    // eslint-disable-next-line
  }, []);

  const reviewPages = Math.ceil(feedReviewsTotal / 6);
  const tripPages = Math.ceil(feedTripsTotal / 3);

  const isEmpty = feedReviewsTotal === 0 && feedTripsTotal === 0;

  return (
    <Box sx={{ width: '100%', pt: 8 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>Following</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          See what the people you follow have been up to.
        </Typography>
      </Box>

      {isEmpty ? (
        <Box sx={{ py: 8, textAlign: 'center', border: '1px dashed', borderColor: 'divider', borderRadius: 2 }}>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 1 }}>
            Follow people to see their trips and reviews here.
          </Typography>
          <Button component={Link} to="/destinations" variant="text" sx={{ textTransform: 'none' }}>
            Discover users
          </Button>
        </Box>
      ) : (
        <>
          <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
            <Tab label={`Reviews (${feedReviewsTotal})`} sx={{ textTransform: 'none', fontWeight: 600 }} />
            <Tab label={`Trips (${feedTripsTotal})`} sx={{ textTransform: 'none', fontWeight: 600 }} />
          </Tabs>

          {tab === 0 && (
            <Box>
              {feedReviews && feedReviews.length > 0 ? (
                <>
                  <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' }, gap: { xs: 2, sm: 3 } }}>
                    {feedReviews.map((r) => (
                      <SpotReviewItemV2 key={r.id} spotReview={r} />
                    ))}
                  </Box>
                  {reviewPages > 1 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                      <Pagination count={reviewPages} page={feedReviewsPage} onChange={(_, p) => getFeedReviews(p)} color="primary" />
                    </Box>
                  )}
                </>
              ) : (
                <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', py: 4 }}>
                  No reviews from people you follow yet.
                </Typography>
              )}
            </Box>
          )}

          {tab === 1 && (
            <Box>
              {feedTrips && feedTrips.length > 0 ? (
                <>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {feedTrips.map((t) => (
                      <TripItem key={t.id} trip={t} showButton={true} />
                    ))}
                  </Box>
                  {tripPages > 1 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                      <Pagination count={tripPages} page={feedTripsPage} onChange={(_, p) => getFeedTrips(p)} color="primary" />
                    </Box>
                  )}
                </>
              ) : (
                <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', py: 4 }}>
                  No trips from people you follow yet.
                </Typography>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default FollowingFeed;
